      import { renderHeader, renderCheckout } from "./main";

      document.addEventListener("DOMContentLoaded", function (event) {
        renderHeader("STSWE25");
        renderCheckout(window.EBWidgets, "stswe-buy-ticket");
      });

      document.addEventListener("DOMContentLoaded", function () {
        const speakerCards = document.querySelectorAll(".speaker-card");
        const sessionDetails = document.getElementById("session-details");
        const mobilePopup = document.getElementById("mobile-popup");
        const popupContent = document.getElementById("popup-content");
        const closePopup = document.getElementById("close-popup");
        let activeSession = null;

        const isMobile = () => window.innerWidth < 768;

        if (isMobile()) {
          sessionDetails.style.display = "none";
        }

        speakerCards.forEach(function (card) {
          card.addEventListener("click", function () {
            const sessionId = this.getAttribute("data-session");
            const contentElement = document.getElementById(sessionId + "-data");

            if (!contentElement) return;

            if (isMobile()) {
              sessionDetails.style.display = "none";
              popupContent.innerHTML = contentElement.innerHTML;
              document.querySelectorAll('#popup-content .watch-recording-link[data-video]').forEach(function(link) {
                link.href = link.dataset.video;
              });
              mobilePopup.style.display = "flex";
              document.body.style.overflow = "hidden";
            } else {
              sessionDetails.style.display = "block";
              sessionDetails.innerHTML = contentElement.innerHTML;
              document.querySelectorAll('#session-details .watch-recording-link[data-video]').forEach(function(link) {
                link.href = link.dataset.video;
              });

              if (
                activeSession === sessionId &&
                !sessionDetails.classList.contains("hidden")
              ) {
                sessionDetails.classList.add("hidden");
                activeSession = null;
              } else {
                sessionDetails.classList.remove("hidden");
                activeSession = sessionId;

                sessionDetails.scrollIntoView({
                  behavior: "smooth",
                  block: "nearest",
                });
              }
            }
          });
        });

        function hidePopup() {
          mobilePopup.style.display = "none";
          document.body.style.overflow = "";
        }

        closePopup.addEventListener("click", hidePopup);

        mobilePopup.addEventListener("click", function (e) {
          if (e.target === mobilePopup) {
            hidePopup();
          }
        });

        window.addEventListener("resize", function () {
          if (isMobile()) {
            sessionDetails.style.display = "none";

            if (mobilePopup.style.display === "flex") {
              mobilePopup.style.display = "none";
              document.body.style.overflow = "";
            }
          } else {
            sessionDetails.style.display = activeSession ? "block" : "none";
          }
        });
      });
